export default __webpack_public_path__ + "static/media/Ballroll_00325.d21481f2.png";